<template>

    <div class="nl">

        <newsletters-v2-header v-show="!isTuto"
                               :category="category"
                               :subscriptions="subscriptionsFromSelectedMailbox"
                               :maxSubscriptions="maxSubscriptions"
                               @updateCategory="updateCategory"
        ></newsletters-v2-header>

        <search v-show="showSearch"
                :list="sortedSubscriptions"
                :searchValue="searchValue"
        ></search>

        <div class="body">

            <multi-scan-completed v-show="showMultiScan"></multi-scan-completed>

            <list v-if="showList"
                  :list="sortedSubscriptions"
                  :category="category"
                  @action="action"
            ></list>

            <cards v-if="showCards"
                   ref="CARDS"
                   :subscriptions="sortedSubscriptions"
                   :category="category"
                   @action="action"
                   @share="share"
            ></cards>

            <senders v-if="showSenders"></senders>

            <tuto v-if="isTuto" @close="initPage"></tuto>

            <empty v-if="showEmpty"></empty>

            <modal-tuto-action ref="modalTutoAction"
                               @close="closeModal"
            ></modal-tuto-action>

            <modal-share ref="MS"></modal-share>

            <modal-rating ref="MR"></modal-rating>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '../assets/ENUM'

import ActionsBatch from '../modules/actionsBatch'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import Cards from '../components/newsletters-v2/Cards'
import Empty from '../components/newsletters-v2/Empty'
import List from '../components/newsletters-v2/List'
import ModalRating from '../components/modal/ModalRating'
import ModalShare from '../components/modal/ModalShare'
import ModalTutoAction from '../components/modal/ModalTutoAction'
import MultiScanCompleted from '../components/newsletters-v2/MultiScanCompleted'
import NewslettersV2Header from '../components/newsletters-v2/Header'
import Search from '../components/newsletters-v2/Search'
import Senders from '../components/newsletters-v2/Senders'
import Tuto from '../components/newsletters-v2/tuto/Tuto'
import Storage from '../helpers/storage'
import Subscription from '../helpers/subscription'


export default {

    name: 'newsletters-v2',

    components: {
        Cards,
        Empty,
        List,
        ModalRating,
        ModalShare,
        ModalTutoAction,
        MultiScanCompleted,
        NewslettersV2Header,
        Search,
        Senders,
        Tuto
    },

    watch: {

        newslettersPage(newPage) {

            switch (newPage) {
                case ENUM.NEWSLETTERS.PAGE.LIST:
                    Tag.pageViewGA(this, 'cleaning_list')
                    UserFlow.setPage(this, 'cleaning_list')
                    break
                case ENUM.NEWSLETTERS.PAGE.CARDS:
                    Tag.pageViewGA(this, 'cleaning_cards')
                    UserFlow.setPage(this, 'cleaning_cards')
                    break
            }
        },

        fetchStatus() {
            this.checkFetchStatus()
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'enoughNewsletters',
            'fetchEndNotif',
            'fetchStatus',
            'isFirstRefreshDone',
            'mailboxes',
            'newsletters',
            'newslettersBus',
            'newslettersPage',
            'newslettersWaiting',
            'newslettersSearchingMode',
            'newslettersSort',
            'selectedMailboxes',
            'searchValue'
        ]),

        ENUM() {
            return ENUM
        },

        isCards() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.CARDS && !this.showEmpty
        },

        isList() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.LIST && !this.showEmpty
        },

        isTuto() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.TUTO
        },

        subscriptionsFromSelectedMailbox() {
            return this.newsletters.filter(newsletter => this.selectedMailboxes.indexOf(newsletter.email) > -1)
        },

        categorisedSubscriptions() {
            switch (this.category) {
                case ENUM.NEWSLETTERS.CATEGORIES.ALL:
                    return this.subscriptionsFromSelectedMailbox
                case ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS:
                    return this.subscriptionsFromSelectedMailbox.filter(subscription => !Subscription.isSpoum(subscription))
                case ENUM.NEWSLETTERS.CATEGORIES.SPAMS:
                    return this.subscriptionsFromSelectedMailbox.filter(subscription => Subscription.isSpoum(subscription))
            }
        },

        filteredSubscriptions() {
            if (this.searching && this.searchValue === '') {
                return []
            } else {
                return this.searchValue
                    ? this.categorisedSubscriptions.filter(item => `${item.name} ${item.sender}`.indexOf(this.searchValue) > -1)
                    : this.categorisedSubscriptions
            }
        },

        sortedSubscriptions() {
            const newArray = JSON.parse(JSON.stringify(this.filteredSubscriptions || []))
            switch (this.newslettersSort) {
                case ENUM.NEWSLETTERS.SORT.MOST_OPEN:
                    return newArray.sort((itemA, itemB) => this.compare(itemB.openRate, itemA.openRate))
                case ENUM.NEWSLETTERS.SORT.LEAST_OPEN:
                    return newArray.sort((itemA, itemB) => this.compare(itemA.openRate, itemB.openRate))
                case ENUM.NEWSLETTERS.SORT.ASCENDING:
                    return newArray.sort((itemA, itemB) => this.compare(itemA.count, itemB.count))
                case ENUM.NEWSLETTERS.SORT.DESCENDING:
                    return newArray.sort((itemA, itemB) => this.compare(itemB.count, itemA.count))
            }
            return newArray
        },

        showEmpty() {
            return !this.isTuto
                && this.subscriptionsFromSelectedMailbox
                && this.subscriptionsFromSelectedMailbox.length === 0
                && this.isFirstRefreshDone
        },

        showList() {
            return (this.isDesktop ? true : this.newslettersSearchingMode !== ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING) && this.isList
        },

        showCards() {
            return this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE && this.isCards
        },

        showSenders() {
            return this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING
        },

        showSearch() {
            return !this.isTuto && (this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE || this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING)
        },

        showMultiScan() {
            return this.fetchEndNotif && !this.showEmpty && this.newslettersWaiting
        },

        maxSubscriptions() {
            return this.subscriptionsFromSelectedMailbox
                .filter(item => item.type === ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS).length
        }

    },

    data() {
        return {
            extras: [],
            category: '',
            searching: false,
            rating: {
                actionCount: 0,
                shownAfter: 20,
                alreadyShown: false,
                opened: false,
                hasRated: false,
                displayCount: 0
            }
        }
    },

    mounted() {
        ActionsBatch.startCounter()
        this.refreshNewsletters()

        this.initPage()

        if(this.fetchStatus !== ENUM.FETCH_STATUS.INITIAL) {
            this.checkFetchStatus()
        }

    },

    methods: {

        ...Vuex.mapActions([
            'fillNewsletters',
            'initNewsletterSort',
            'refreshNewsletters',
            'updateNewslettersPage'
        ]),

        initPage() {

            this.initNewsletterSort()

            const tutoDone = !Storage.getItem(Storage.KEYS.TUTO_NEWSLETTERS)
            if (tutoDone) {
                this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.TUTO)
            } else {

                const savedPage = Storage.getItem(Storage.KEYS.NEWSLETTERS_PAGE)
                if (savedPage && Object.values(ENUM.NEWSLETTERS.PAGE).includes(savedPage)) {
                    this.updateNewslettersPage(savedPage)
                    Storage.removeItem(Storage.KEYS.NEWSLETTERS_PAGE)
                } else {
                    this.isDesktop
                        ? this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.LIST)
                        : this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.CARDS)
                }
            }

            this.updateCategory(ENUM.NEWSLETTERS.CATEGORIES.ALL)
        },

        updateCategory(newCategory) {
            this.category = newCategory
        },

        action({enumAction, senders}) {
            if (this.needConfirmation(enumAction)) {
                this.$refs.modalTutoAction.open(senders, enumAction)
            } else {
                const cleanedSendersLength = ActionsBatch.requestAction({enumAction, senders})
                this.updateRating(cleanedSendersLength)
            }
        },

        needConfirmation(enumAction) {
            if (this.isCards) {
                return false
            }
            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    return !Storage.getItem('disableModalUnsubscribe')
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    return !Storage.getItem('disableModalDelete')
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    return !Storage.getItem('disableModalKeep')
            }
        },

        closeModal({accept, enumAction, senders}) {
            if (accept) {
                const cleanedSendersLength = ActionsBatch.requestAction({enumAction, senders})
                this.updateRating(cleanedSendersLength)
            } else if (this.isCards) {
                //refresh Cards if rollback after throw out
                this.$refs.CARDS.refresh()
            }
        },

        compare(itemA, itemB) {
            if (itemA < itemB) {
                return -1
            }
            if (itemA > itemB) {
                return 1
            }
            return 0
        },

        share() {
            this.$refs.MS.open()
        },

        updateRating(length) {

            this.rating.actionCount += length

            if (!this.rating.alreadyShown && this.rating.displayCount < 2) {
                if (!this.rating.opened) {
                    if (this.rating.actionCount >= this.rating.shownAfter) {
                        this.rating.displayCount += 1
                        this.rating.opened = true
                        this.rating.shownAfter = this.rating.actionCount + 40
                        this.$refs.MR.open()
                    }
                }
            }
        },

        checkFetchStatus() {
            if (this.fetchStatus !== ENUM.FETCH_STATUS.DONE && this.fetchStatus !== ENUM.FETCH_STATUS.PARTIAL) {
                if(this.fetchStatus === ENUM.FETCH_STATUS.PENDING && !this.enoughNewsletters) {
                    this.$router.push({path: '/fetch'})
                }
            } else {
                return true
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.nl {
    background-color: $timberwolf;
    position: relative;

    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
    }

    .body {
        display: flex;
        flex: 1;
        position: relative;
    }
}

</style>
